const feiche = [{
  desc: '分支机构列表',
  options: {
    url: '/partnerBranch/queryPartnerBranchPage',
    method: 'post'
  }
}, {
  desc: '添加分支机构',
  options: {
    url: '/partnerBranch/saveOrUpdatePartnerBranch',
    method: 'post'
  }
}, {
  desc: '获取当前旗舰版分支可创建机构和可分配坐席数量信息',
  options: {
    url: '/partnerBranch/getPartnerBranchAndSeatInfo',
    method: 'post'
  }
}, {
  desc: '禁用启用分支机构',
  options: {
    url: '/partnerBranch/updatePartnerBranchStatus',
    method: 'post'
  }
}, {
  desc: '获取人员信息',
  options: {
    url: '/customer/queryCustomerInfos',
    method: 'post'
  }
}, {
  desc: '获取坐席信息',
  options: {
    url: '/seats/querySeatsInfos',
    method: 'post'
  }
}, {
  desc: '组织机构信息',
  options: {
    url: '/customer/queryOrgInfos',
    method: 'post'
  }
}, {
  desc: '获取分支机构信息接口',
  options: {
    url: '/branch/queryBranchInfo',
    method: 'post'
  }
}, {
  desc: '生成pdf地址',
  options: {
    url: '/salesContract/htmlToPdf',
    method: 'post'
  }
}, {
  desc: '获取工号信息',
  options: {
    url: '/jobNo/queryPartnerJobNoInfos',
    method: 'post'
  }
}, {
  desc: '批量组织机构授权和取消授权接口',
  options: {
    url: '/jobNo/batchUpdateJobNoInfos',
    method: 'post'
  }
}, {
  desc: '分支机构业绩报表',
  options: {
    url: '/report/branchOrgPerformanceReportQuery',
    method: 'post'
  }
}, {
  desc: '导出分支机构业绩报表',
  options: {
    url: '/report/exportBranchOrgPerformanceReport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '日周月报表',
  options: {
    url: '/report/dwmReportQuery',
    method: 'post'
  }
}, {
  desc: '分支机构费用报表',
  options: {
    url: '/report/queryOrganizaitonSettleReport',
    method: 'post'
  }
}, {
  desc: '导出分支机构费用报表',
  options: {
    url: '/report/exportOrganizaitonSettleReport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '流水账',
  options: {
    url: '/report/queryStandingBook',
    method: 'post'
  }
}, {
  desc: '出单员业绩报表',
  options: {
    url: '/report/queryOutPerformance',
    method: 'post'
  }
}, {
  desc: '导出出单员业绩统计',
  options: {
    url: '/report/exportOutPerformance',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '监管报表台账',
  options: {
    url: '/report/queryRegulatoryReport',
    method: 'post'
  }
}, {
  desc: '趋势分析',
  options: {
    url: '/statistic/getTrendAnalysis',
    method: 'post'
  }
}, {
  desc: '业务员保司维度统计',
  options: {
    url: '/statistic/getSalesmanBySupplierAnalysis',
    method: 'post'
  }
}, {
  desc: '业务员日报分析',
  options: {
    url: '/statistic/getSalesmanDailyAnalysis',
    method: 'post'
  }
}, {
  desc: '获取旗舰版所有分支机构列表',
  options: {
    url: '/partnerBranch/queryPartnerBranchList',
    method: 'post'
  }
}, {
  desc: '保险公司分析数据',
  options: {
    url: '/statistic/getInsSupplierAnalysis',
    method: 'post'
  }
}, {
  desc: '区域占比分析',
  options: {
    url: '/statistic/getRegionAnalysis',
    method: 'post'
  }
}, {
  desc: '车型占比分析数据',
  options: {
    url: '/statistic/getVehicleTypeAnalysis',
    method: 'post'
  }
}, {
  desc: '新旧车占比分析',
  options: {
    url: '/statistic/getNewOldCarAnalysis',
    method: 'post'
  }
}, {
  desc: '业务员统计分析',
  options: {
    url: '/statistic/getSalesmanAnalysis',
    method: 'post'
  }
}, {
  desc: '工号数据分析',
  options: {
    url: '/statistic/getJobNoAnalysis',
    method: 'post'
  }
}, {
  desc: '业务来源/组织部门维度分析',
  options: {
    url: '/statistic/getDimensionAnalysis',
    method: 'post'
  }
}, {
  desc: '分支机构车型分析',
  options: {
    url: '/statistic/getEmbranchmentBranchAnalysis',
    method: 'post'
  }
}, {
  desc: '业务来源分析导出',
  options: {
    url: '/statistic/exportDimensionAnalysis',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '工号数据分析导出',
  options: {
    url: '/statistic/exportJobNoAnalysis',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '保险公司分析导出',
  options: {
    url: '/statistic/exportInsSupplierAnalysis',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '部门业绩汇总',
  options: {
    url: '/statistic/getOrganizationReport',
    method: 'post',
    needCustomMessage: true
  }
}, {
  desc: '部门业绩汇总导出',
  options: {
    url: '/statistic/exportOrganizationReport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '险种占比分析',
  options: {
    url: 'statistic/branchCarInsTypeAnalysisStatistic',
    method: 'post'
  }
}, {
  desc: '报表保单/结算明细导出',
  options: {
    url: '/statistic/exportReportPolicyDetail',
    method: 'post',
    // 明细含分页查询及Excel生成，单独设置有限等待时间。
    timeout: 180000,
    responseType: 'arraybuffer'
  }
}, {
  desc: '分支机构监管报表列表',
  options: {
    url: '/report/getBranchOrgSupervisionReport',
    method: 'post'
  }
}, {
  desc: '分支机构监管报表导出',
  options: {
    url: '/report/getBranchOrgSupervisionReportExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}]

export default feiche



// WEBPACK FOOTER //
// ./src/api/ultimate.js